import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} reported in your vicinity",
  "alert.toast.escalation": "{hazard} nearby has escalated",
  "alert.toast.inPath": "{hazard} is now advancing toward your location",
  "alert.toast.allClear": "Conditions normal near {place}",
  "alert.toast.tap": "Open for details and safety guidance",
  "alert.takeover.title": "{hazard} — immediate action required",
  "alert.takeover.details": "View full report",
  "now.status.allClear": "No active hazards.",
  "now.status.stayAware": "Remain alert.",
  "now.status.sub.allClear": "No active hazards within your watch radius.",
  "now.activity.empty": "No activity reported nearby.",
  "onboarding.promise.tagline": "A community early-warning network.",
  "onboarding.promise.continue": "Begin",
  "region.unsupported.title": "Location outside coverage area",
  "you.voice.intro": "Select the tone Beacon uses to communicate.",
};
